export default __webpack_public_path__ + "static/media/dashboard_Packages_zero.a09a5069.svg";